import { TextButton } from '@oneaudi/unified-web-components';
import styled from 'styled-components';

export const MapContainer = styled.div`
  // - this a workaround for Safari Browser
  // in same cases with flex-box the child will not take parent size for "%" values
  position: absolute;
  top: 0;
  left: 0;
  // -

  height: 100%;
  width: 100%;
  & .gm-control-active {
    border-radius: 0 !important;
  }
  & .gmnoprint {
    > div {
      border-radius: 0 !important;
    }
  }
`;

export const MobileSearchInThisAreaButtonContainer = styled.div.attrs({
  'data-test-id': 'search-in-this-area-container-mobile',
})`
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
`;

export const SearchInThisAreaButtonContainer = styled(TextButton)<{
  isMobile: boolean;
}>`
  background-color: #ffffff;
  ${(props) =>
    props.isMobile
      ? 'position: relative; top: 20px; width: fit-content;'
      : `position: absolute; left: 50%; transform: translate(-50%, 0); top: 20px`};
  z-index: 20;
  border: none;
  box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
`;
